import { useQuery } from "@tanstack/react-query";

import { getPropertiesUsages } from "api/tenants";
import { queryKeys } from "./queryKeys";

interface UseGetPropertiesUsagesOptions {
  enabled?: boolean;
}

export const useGetPropertiesUsages = (
  options: UseGetPropertiesUsagesOptions = {},
) => {
  const { enabled = true } = options;

  return useQuery({
    queryKey: queryKeys.properties.usages(),
    queryFn: getPropertiesUsages,
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes - usages don't change often
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
};
